import { featureConstant, featureFlag } from '@/constants/configuration/feature.js';

export const feature = (featureName) => {
    const currentEnv = process.env.REACT_APP_ENV || 'prod';
    return featureFlag[featureName]?.[currentEnv] ?? false;
}

export const featureV2 = (featureName, features) => {
	return features?.includes(featureName)
}

const multidexFeatureEnvMap = {
    sgtradex: ['dev', 'uat', 'test'],
    sgbuildex: []
}

export const multidexChecker = (dexEnv, reactAppEnv) => {
    if (multidexFeatureEnvMap[dexEnv]) {
        return multidexFeatureEnvMap[dexEnv].includes(reactAppEnv);
    }
};

export const features = featureConstant;
